import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';

import * as fromRoot from 'src/app/modules/ngrx-store/reducers';
import * as Selectors from 'src/app/modules/ngrx-store/selectors';
import { ConstructionProgressFacade } from 'src/app/modules/ngrx-store/construction-progress/construction-progress.facade';
import { ServiceRequestsFacade } from 'src/app/modules/ngrx-store/service-requests/service-requests.facade';
import { AppFacade } from 'src/app/modules/ngrx-store/app/app.facade';
import { YourHomeFacade } from 'src/app/modules/ngrx-store/your-home/your-home.facade';
import { MessageFacade } from 'src/app/modules/ngrx-store/message/message.facade';

@Injectable()
export class RootFacade {
	postCloseWithUpdates$ = this.store.pipe(select(Selectors.postCloseWithUpdates));
	showMessageCenter$ = this.store.pipe(select(Selectors.showMessageCenter));

	constructionProgressFacade: ConstructionProgressFacade;
	appFacade: AppFacade;
	yourHomeFacade: YourHomeFacade;
	serviceRequestsFacade: ServiceRequestsFacade;
	messageFacade: MessageFacade;

	constructor(
		constructionProgressFacade: ConstructionProgressFacade,
		appFacade: AppFacade,
		yourHomeFacade: YourHomeFacade,
		serviceRequestsFacade: ServiceRequestsFacade,
		messageFacade: MessageFacade,
		protected store: Store<fromRoot.State>
	) {
		this.constructionProgressFacade = constructionProgressFacade;
		this.appFacade = appFacade;
		this.yourHomeFacade = yourHomeFacade;
		this.serviceRequestsFacade = serviceRequestsFacade;
		this.messageFacade = messageFacade;
	}
}